import { BaseEntity } from '../../models';
import { tipoClassificacaoSituacaoAtivo } from './tipo-classificacao-situacao';
import { TipoClassificacaoKPIs } from './kpis';
import { crossSellSem } from '../common/cross-sell';


export class TipoClassificacao implements BaseEntity, TipoClassificacaoKPIs {
    readonly id: number;
    idEmpresa: number;
    nivel: number;
    codigo: number;
    nome: string;
    cadastro: number;
    situacao: number;
    referenciaIntegracaoErp: number;

    // KPIS
    /** Indicador de Cross Sell */
    crossSell: number;

    constructor() {
        this.situacao = tipoClassificacaoSituacaoAtivo.id;
        this.crossSell = crossSellSem.id;
    }
}
